export default __webpack_public_path__ + "static/media/MYA.05be7c2f.svg";